import axios from "axios";
// let locationorigin = window.location.origin
// let regexpatt = /\W?\d*$/
// let windowobj = locationorigin.replace(regexpatt, "");

const logClient = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? `${process.env.VUE_APP_LOCAL_API_ORIGIN}`
      : `${process.env.VUE_APP_LIVE_API_ORIGIN}`,
  headers: { Pragma: "no-cache", "Cache-Control": "no-store" }
});

// const apiClientV2 = axios.create({
//   baseURL:
//     process.env.NODE_ENV == "development"
//       ? `${process.env.VUE_APP_LOCAL_API_V2_ORIGIN}`
//       : `${process.env.VUE_APP_LIVE_API_V2_ORIGIN}`,
//   headers: {
//     Pragma: "no-cache",
//     "Cache-Control": "no-store"
//   }
// });

export default {
  checkemail(email) {
    return logClient.post("/user.class.php", {
      action: "check-email",
      email: email
    });
  },
  signUserup(details) {
    return logClient.post("/user.class.php", {
      action: "sign-up",
      details: details
    });
  },
  emailConfirm(cid) {
    return logClient.post("/user.class.php", {
      action: "confirm-email",
      cid: cid
    });
  },
  loginUser(userdetails) {
    let saction = "Login";

    if (userdetails.page == "login") {
      saction = "Login";
    } else if (userdetails.page == "landing") {
      saction = "Remember";
    }

    return logClient.post("/user.class.php", {
      action: saction,
      details: userdetails
    });
  },

  loginOrgCandidate(userdetails) {

    return logClient.post("/organization.class.php", {
      action: "candidate-login",
      details: userdetails
    });
  },

  getVcode() {
    return logClient.post("/user.class.php", {
      action: "get-voucher"
    });
  },
  upgrader(upgradeobj) {
    return logClient.post("/user.class.php", {
      action: "upgrade-user",
      upgradeobj: upgradeobj
    });
  },
  payVerify(refObj) {
    return logClient.post("/user.class.php", {
      action: "verify-pay",
      refObj
    });
  },
  pwordForgot(emailobj) {
    return logClient.post("/user.class.php", {
      action: "send-rtoken",
      emailobj: emailobj
    });
  },
  pwordReset(pwordobj) {
    return logClient.post("/user.class.php", {
      action: "reset-pword",
      pwordobj: pwordobj
    });
  },
  getDetails(trackid){
    return logClient.post("/user.class.php", {
      action : "get-user-details",
      trackid
    })
  },
  deleteAccountUser(trackid){
    return logClient.post("/user.class.php", {
      action : "delete-user",
      trackid
    })
  },  
  checkorgsname(orgsname) {
    return logClient.post("/user.class.php", {
      action: "check-orgsname",
      orgsname: orgsname
    });
  },
  checkorgname(orgname) {
    return logClient.post("/user.class.php", {
      action: "check-orgname",
      orgname: orgname
    });
  },
  resendMail(email, origin) {
    return logClient.post("/user.class.php", {
      action: "resend-verify-email",
      email,
      origin
    });
  },
  saveOrgProfile(profileObj) {
    return logClient.post("/user.class.php", {
      action: "Update-Org-Profile",
      profileObj
    });
  },
  getPremiumPlans() {
    return logClient.get("/user.class.php?get=plans");
  },
  getOrgDetails(orgShortname) {
    return logClient.post(`/organization.class.php`, {
      action: "get-organization-details",
      orgShortname
    });
  },
};
